<template>
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 11.2L16.9189 7L38 25L16.9189 43L12 38.8L28.1622 25L12 11.2Z" fill="white"/>
  </svg>
</template>
